const groups = {
  name_en: 'English name',
  name_fr: 'French name',
  description_en: 'English description',
  description_fr: 'French description',
  number_of_payments: 'Number of payments',
};

export default groups;
